<template>
  <el-select
    v-model="model.productItem"
    :disabled="disabled"
    clearable
    :loading="loading"
    value-key="id"
    :placeholder="placeholder"
    @change="selectProductItem">
    <el-option
      v-for="item in productItems"
      :key="item.id"
      :label="item.releaseYear"
      :value="item">
    </el-option>

  </el-select>
</template>
<script>
import productItemApi from '@/services/API/productItem'
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
	name: 'TechnicalSheetSelect',
  props: {
    productItem: {
      type: Object,
      default: null,
    },
		product : {
      type : Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false
    }
	},
	data() {
		return {
      model : {
        productItem : null
      },
      productItems : [],
      loading : false
	   }
   },
  computed: {
    placeholder () {
      return this.$i18n.t('products.details.technicalSheetSelectPlaceholder');
    }
  },
  components : {
  },
  methods : {
    setModel() {
      
      if (this.product != null) {
        return new Promise((resolve) => {
          // if (_.isEmpty(this.productItems)) {
            return resolve(this.fetchProductItems(_.get(this.product, 'id')));
          // }
          // return resolve(null);
        })
        .then(() => {
          if (this.productItem != null) {
            this.model.productItem = _.find(this.productItems, pi => pi.id === this.productItem.id);
          } else {
            this.model.productItem = null;
          }
        })
      }
    },
    selectProductItem(productItem){
      this.$emit('change', productItem);
    },
    fetchProductItems(productId){
      this.loading = true;
      return productItemApi.fetchProductItems({ productId })
        .then(productItems => {
          this.productItems = productItems;
          this.loading = false;
          return productItems;
        })
        .catch((err) => {
          this.loading = false;
          this.productItems = [];
          return null;
        })
    }
  },
  watch: {
    product: function(val) {
      this.setModel();
    },
    productItem: function(val) {
      this.setModel();
    }
  },
  created(){
    this.setModel();
  }
}
</script>
<style lang="scss" scoped>

</style>
